var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "flex-column form-fields-company" },
    [
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "name",
            label: _vm.$t.__("common.labels.society_name")
          }
        },
        [
          !_vm.getLoading
            ? _c("el-input", {
                ref: "name",
                attrs: {
                  name: "company",
                  autocomplete: "on",
                  "data-bot": _vm.getDatabot("name", _vm.currentStore)
                },
                on: { input: _vm.searchCompanyByName },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.openPopup()
                  }
                },
                model: {
                  value: _vm.name,
                  callback: function($$v) {
                    _vm.name = $$v
                  },
                  expression: "name"
                }
              })
            : _c("input-loader", {
                attrs: {
                  label: _vm.$t.__(
                    "thirds.thirdscomponents.FormFieldsCompany.search_in_progress"
                  )
                }
              })
        ],
        1
      ),
      _vm._v(" "),
      _vm.searchAvailable
        ? _c("div", { staticClass: "flex-row mb-2 ai-center" }, [
            _c(
              "a",
              {
                staticClass: "fs-3 ln-20 mr-2 semibold hover-primary-100",
                attrs: {
                  href: "javascript:;",
                  "data-bot": _vm.getDatabot("name-link", _vm.currentStore)
                },
                on: {
                  click: function($event) {
                    return _vm.openPopup()
                  }
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$l10n.__(
                        "Rechercher automatiquement les informations de la société"
                      )
                    ) +
                    "\n        "
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.companiesList.length > 0
        ? _c(
            "div",
            { staticClass: "mt-0 mb-3" },
            [
              _c("el-alert", {
                staticClass: "mb-2 mt-2 alert alert-warning",
                attrs: {
                  closable: false,
                  title: _vm.$t.__(
                    "common.labels.company_already_exist_in_your_directory"
                  ),
                  type: "warning"
                }
              }),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(_vm.companiesList, function(company, index) {
                  return _c("form-fields-companies-list", {
                    key: index,
                    staticClass:
                      "form-fields-companies-list br b-1-gray-05 mb-2 gray-0-bkg px-3",
                    staticStyle: { height: "66px" },
                    attrs: {
                      company: company,
                      "allow-badge": "",
                      overview: true
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "type", label: _vm.$t.__("common.labels.type") } },
        [
          _c(
            "el-select",
            {
              staticClass: "wp-10",
              attrs: { "data-bot": _vm.getDatabot("type", _vm.currentStore) },
              model: {
                value: _vm.type,
                callback: function($$v) {
                  _vm.type = $$v
                },
                expression: "type"
              }
            },
            _vm._l(_vm.typeList, function(option) {
              return _c("el-option", {
                key: option.label,
                attrs: { value: option, label: _vm.tagsHuman[option].label }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "reference",
            label: _vm.$t.__("common.labels.reference")
          }
        },
        [
          _c("el-input", {
            attrs: {
              autocomplete: "off",
              "data-bot": _vm.getDatabot("reference", _vm.currentStore)
            },
            model: {
              value: _vm.reference,
              callback: function($$v) {
                _vm.reference = $$v
              },
              expression: "reference"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: { prop: "website", label: _vm.$t.__("common.labels.web_site") }
        },
        [
          _c("el-input", {
            ref: "website",
            attrs: {
              name: "website",
              autocomplete: "off",
              placeholder: "https://www.website.com",
              "data-bot": _vm.getDatabot("website", _vm.currentStore)
            },
            model: {
              value: _vm.website,
              callback: function($$v) {
                _vm.website = $$v
              },
              expression: "website"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.type !== "supplier"
        ? _c(
            "el-form-item",
            {
              attrs: {
                prop: "businessSegments",
                label: _vm.$t.__("common.labels.activity_area")
              }
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "wp-10",
                  attrs: {
                    "data-bot": _vm.getDatabot(
                      "business-segments",
                      _vm.currentStore
                    )
                  },
                  model: {
                    value: _vm.businessSegments,
                    callback: function($$v) {
                      _vm.businessSegments = $$v
                    },
                    expression: "businessSegments"
                  }
                },
                _vm._l(_vm.businessSegmentsList, function(business) {
                  return _c("el-option", {
                    key: business.label,
                    attrs: { value: business, label: business.label }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          staticClass: "flex-column",
          attrs: {
            prop: "numberOfEmployees",
            label: _vm.$t.__("common.labels.employees_number")
          }
        },
        [
          _c(
            "el-select",
            {
              staticClass: "wp-5",
              attrs: {
                "data-bot": _vm.getDatabot(
                  "number-of-employees",
                  _vm.currentStore
                )
              },
              model: {
                value: _vm.numberOfEmployees,
                callback: function($$v) {
                  _vm.numberOfEmployees = $$v
                },
                expression: "numberOfEmployees"
              }
            },
            _vm._l(_vm.employeesNumberList, function(option) {
              return _c("el-option", {
                key: option.label,
                attrs: { value: option, label: option.label }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "email", label: _vm.$t.__("common.labels.email") } },
        [
          _c("el-input", {
            ref: "email",
            attrs: {
              autocomplete: "off",
              placeholder: "contact@societe.com",
              "data-bot": _vm.getDatabot("email", _vm.currentStore)
            },
            model: {
              value: _vm.email,
              callback: function($$v) {
                _vm.email = $$v
              },
              expression: "email"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("contact-number", {
        attrs: { "current-store": _vm.currentStore, error: _vm.error }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }